'use client';

import useAutenticacaoAcoes from '@/hooks/useAutenticacaoACoes';
import {
  listarMeusPedidosAvulsos,
  listarMinhasAssinaturas,
} from '@/services/pedidos';
import {
  AssinaturaListagem,
  PedidoAvulsoListagem,
} from '@/services/types/pedidos';
import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

interface MeusPedidosDataType {
  pedidosAvulsos: Array<PedidoAvulsoListagem> | null;
  setPedidosAvulsos: Dispatch<SetStateAction<PedidoAvulsoListagem[] | null>>;
  // eslint-disable-next-line no-unused-vars
  recuperarMeusPedidosAvulsos: (filtros?: string) => Promise<void>;
  assinaturas: Array<AssinaturaListagem> | null;
  setAssinaturas: Dispatch<SetStateAction<AssinaturaListagem[] | null>>;
  // eslint-disable-next-line no-unused-vars
  recuperarMinhasAssinaturas: (filtros?: string) => Promise<void>;
  recuperandoValores: boolean;
}

export const MeusPedidosDataContext = createContext<
  MeusPedidosDataType | undefined
>(undefined);

export const MeusPedidosDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [recuperandoValores, setRecuperandoValores] = useState<boolean>(false);

  const [pedidosAvulsos, setPedidosAvulsos] =
    useState<Array<PedidoAvulsoListagem> | null>(null);
  const [assinaturas, setAssinaturas] =
    useState<Array<AssinaturaListagem> | null>(null);

  const { deslogar } = useAutenticacaoAcoes();

  async function recuperarMeusPedidosAvulsos(filtros?: string) {
    if (pedidosAvulsos?.length || recuperandoValores) return;
    setRecuperandoValores(true);
    const meusPedidosDataFromServer = await listarMeusPedidosAvulsos(
      filtros ? { filtros } : {},
    );

    if (
      typeof meusPedidosDataFromServer.autenticado === 'boolean' &&
      !meusPedidosDataFromServer.autenticado
    )
      return deslogar();

    setPedidosAvulsos(meusPedidosDataFromServer.dados.lista);
    setRecuperandoValores(false);
  }

  async function recuperarMinhasAssinaturas(filtros?: string) {
    if (assinaturas?.length || recuperandoValores) return;
    setRecuperandoValores(true);
    const minhasAssinaturasFromServer = await listarMinhasAssinaturas(
      filtros ? { filtros } : {},
    );

    if (
      typeof minhasAssinaturasFromServer.autenticado === 'boolean' &&
      !minhasAssinaturasFromServer.autenticado
    )
      return deslogar();

    setAssinaturas(minhasAssinaturasFromServer?.dados?.lista);
    setRecuperandoValores(false);
  }

  return (
    <MeusPedidosDataContext.Provider
      value={{
        pedidosAvulsos,
        setPedidosAvulsos,
        recuperarMeusPedidosAvulsos,
        assinaturas,
        setAssinaturas,
        recuperarMinhasAssinaturas,
        recuperandoValores,
      }}
    >
      {children}
    </MeusPedidosDataContext.Provider>
  );
};
